<template>
    <div class="custom-header color-#fff text-18px font-900 flex justify-between items-center pb-18px">
        <div class="flex items-center">
            <div class="w-38px mr-6px">
                <img src="@/assets/images/home/logo.svg" class="w-full h-full"></img>
            </div>
            <div class="logo-text">
                {{ JSON.parse(parsed || '{}').AppName || 'RoleplayGF' }}
            </div>
        </div>
        <div class="flex items-center justify-center">
            <div class="flex bg-#FFFFFF header-round rounded-10 p-4px pl-10px pr-5px items-center justify-center"
                @click="handleAdd">
                <img src="@/assets/images/home/crystal.webp" class="w-14px h-14px mr-5px mt-1px"></img>
                <div class="text-14px font-500 color-#fff">
                    {{ msgCost }}
                </div>
                <img src="@/assets/images/home/add.svg" class="w-20px h-20px ml-5px"></img>
            </div>
            <div class="ml-15px flex items-center justify-center" @click.stop.prevent="handleSetting"
                @touchend.stop.prevent="handleSetting" v-if="showSetting">
                <img src="@/assets/images/mine/settings.svg" class="w-24px h-24px"></img>
            </div>
            <div class="ml-15px flex items-center justify-center" @click.stop.prevent="handleDiscord"
                @touchend.stop.prevent="handleDiscord" v-else>
                <img src="@/assets/images/home/discord.svg" class="w-30px h-30px"></img>
            </div>

        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useUserStore } from '@/stores/user'
import { useRouter } from 'vue-router'
import { showLoadingToast, showSuccessToast, showErrorToast, closeToast } from '@/utils/toast'
const userStore = useUserStore()
const msgCost = computed(() => userStore.msgCost)
const router = useRouter()
const parsed = localStorage.getItem('ai-chat-parsed')
const userInfo = computed(() => userStore.getTouristInfo())
const userData = computed(() => JSON.parse(localStorage.getItem('ai-chat-user') || '{}'))
const props = defineProps<{
    showSetting?: boolean
}>()
onMounted(() => {
    userStore.getMsgCost()
})

const handleAdd = () => {
    router.push({ name: 'Store' })
}

/**
 * 处理discord
 */
const handleDiscord = () => {
    showLoadingToast('Processing...', { duration: 2000 })
    console.log(userData.value.contactUs);
    const url = userData.value.contactUs
    
    window.location.href = userData.value.contactUs
    setTimeout(() => {
        closeToast()
    }, 2000)
}

/**
 * 处理设置
 */
const handleSetting = () => {
    router.push({ name: 'Setting' })
}
onMounted(() => {
    closeToast()
})
</script>

<style scoped lang="scss">
.header-round {
    background: rgba(255, 255, 255, 0.1);
}

.logo-text {
    background: linear-gradient(45.00000000000004deg, #7C9CFF 0%, #7058F8 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}
</style>